import { useMyOrderIntentionsContext } from 'contexts/MyOrderIntentionsContext';
import { OrderIntention } from 'model/OrderIntention';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { myOrderIntentionEditActions } from 'store/state/slices';
import OrderIntentionsCardList from '../CardList/OrderIntentionsCardList';
import OrderIntentionModals from './OrderIntentionModals';
import { useOrderIntentionSelection } from './useOrderIntentionSelection';

interface Props {
  data: OrderIntention[] | undefined;
  isLoading: boolean;
  hasSearched: boolean;
}

export default function ResponsiveList({
  data,
  isLoading,
  hasSearched,
}: Props) {
  const dispatch = useDispatch();
  const {
    setSelectedOrderIntentions,
    setSelectedOrderIntentionsKeys,
    setShowJustificationModal,
  } = useMyOrderIntentionsContext();
  const selection = useOrderIntentionSelection(data);
  const openJustification = useCallback(
    (record: OrderIntention) => {
      setSelectedOrderIntentions([record]);
      setSelectedOrderIntentionsKeys([record.id]);
      setShowJustificationModal(true);
      dispatch(myOrderIntentionEditActions.setIdsJustification([record.id]));
      dispatch(myOrderIntentionEditActions.setItemsJustification([record]));
    },
    [
      dispatch,
      setSelectedOrderIntentions,
      setSelectedOrderIntentionsKeys,
      setShowJustificationModal,
    ],
  );

  return (
    <>
      <OrderIntentionModals data={data} />
      <OrderIntentionsCardList
        orders={data ?? []}
        isLoading={isLoading}
        hasSearched={hasSearched}
        selection={selection}
        onOpenJustification={openJustification}
      />
    </>
  );
}
